import script from "./employee-coverage-table.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-coverage-table.vue?vue&type=script&setup=true&lang=js"

import "./employee-coverage-table.vue?vue&type=style&index=0&id=4fb8ce30&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb8ce30"]])

export default __exports__